/* Great Lakes mega menu — UX layer: backdrop, arrow-key movement inside panels, hover prefetch. */
(function () {
  'use strict';
  if (window.__gllfMegaPlus) return;
  window.__gllfMegaPlus = true;

  function init() {
    var desktop = document.querySelector('[data-gllf-mega-desktop]');
    if (!desktop || desktop.dataset.gllfPlus) return;
    desktop.dataset.gllfPlus = '1';
    var disclosures = Array.prototype.slice.call(desktop.querySelectorAll('[data-gllf-mega-disclosure]'));

    var backdrop = document.querySelector('.gllf-mega-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'gllf-mega-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      document.body.appendChild(backdrop);
    }
    function sync() {
      var anyOpen = disclosures.some(function (d) { return d.open; });
      document.documentElement.classList.toggle('gllf-mega-panel-open', anyOpen);
    }
    disclosures.forEach(function (d) { d.addEventListener('toggle', sync); });
    backdrop.addEventListener('click', function () { disclosures.forEach(function (d) { d.open = false; }); sync(); });

    // Up/Down arrows move between links inside the open panel; Home/End jump.
    desktop.addEventListener('keydown', function (e) {
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(e.key) === -1) return;
      var panel = e.target.closest('.gllf-mega-desktop__panel');
      if (!panel) return;
      var links = Array.prototype.slice.call(panel.querySelectorAll('a[href]'));
      var i = links.indexOf(e.target);
      if (i === -1) return;
      e.preventDefault();
      var next = e.key === 'Home' ? 0 : e.key === 'End' ? links.length - 1 : i + (e.key === 'ArrowDown' ? 1 : -1);
      if (next < 0) { var trigger = panel.parentElement.querySelector(':scope > summary'); if (trigger) trigger.focus(); return; }
      if (links[next]) links[next].focus();
    });

    // Prefetch same-origin pages on hover intent so the next page opens faster.
    var done = {};
    function prefetch(a) {
      try {
        var u = new URL(a.href, location.href);
        if (u.origin !== location.origin || done[u.pathname]) return;
        done[u.pathname] = 1;
        var l = document.createElement('link'); l.rel = 'prefetch'; l.href = u.pathname; document.head.appendChild(l);
      } catch (err) {}
    }
    var timer;
    document.addEventListener('mouseover', function (e) {
      var a = e.target.closest && e.target.closest('a[data-gllf-mega-link]');
      if (!a) return;
      clearTimeout(timer); timer = setTimeout(function () { prefetch(a); }, 120);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();

/* ---------- Mobile menu: utility tiles + smart search ---------- */
(function () {
  'use strict';
  if (window.__gllfMobileSearch) return;
  window.__gllfMobileSearch = true;

  var RECENT = 'gllf_recent_searches_v1';
  var POPULAR = ['Hidcote', 'Munstead', 'Phenomenal', 'Bare root', '72-cell trays', 'Culinary lavender', 'Bath & body', 'Gifts'];
  var TOOLS = [
    ['Plant Finder', '/pages/plant-finder', 'M11 4a7 7 0 1 0 4.2 12.6L20 21.4 21.4 20l-4.8-4.8A7 7 0 0 0 11 4Z'],
    ['Frost Dates', '/pages/frost-date-estimator', 'M12 2v20M4.9 4.9l14.2 14.2M2 12h20M4.9 19.1 19.1 4.9'],
    ['Zone Finder', '/pages/growing-zone', 'M12 21s-7-6.2-7-11.5a7 7 0 1 1 14 0C19 14.8 12 21 12 21Zm0-8.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'],
    ['Plant Health', '/pages/plant-health-checker', 'M12 21c-5-3.3-8-6.6-8-10.2A4.8 4.8 0 0 1 12 7a4.8 4.8 0 0 1 8 3.8c0 3.6-3 6.9-8 10.2ZM12 10v6M9 13h6']
  ];
  function read(k) { try { var v = JSON.parse(localStorage.getItem(k)); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  function write(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function mark(text, q) {
    var t = esc(text); if (!q) return t;
    var words = q.trim().split(/\s+/).filter(function (w) { return w.length > 1; }).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    return words.length ? t.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>') : t;
  }
  function money(p) { var n = parseFloat(p); if (!isFinite(n)) return ''; if (String(p).indexOf('.') === -1 && n > 999) n = n / 100; return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(n); }
  function img(u) { if (!u) return ''; u = String(u); if (u.indexOf('//') === 0) u = 'https:' + u; return u.replace(/(\.(jpe?g|png|webp|gif))(\?|$)/i, '_120x$1$3'); }
  function addRecent(q) { q = String(q || '').trim(); if (q.length < 2) return; var r = read(RECENT).filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); }); r.unshift(q); write(RECENT, r.slice(0, 6)); }
  var ICON = function (d) { return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>'; };

  function closeMenu(mobile) { var r = mobile.querySelector('[data-gllf-mobile-root]'); if (r) r.open = false; }

  /* design-v1: a Lists tile next to Saved and Compare (opens the shortlist's Lists tab). */
  function addListsTile(mobile) {
    var saved = mobile.querySelector('[data-gllf-tile="wishlist"]');
    if (!saved || mobile.querySelector('[data-gllf-tile="lists"]') || !window.GLLFBoards || !window.GLLFBoards.ready) return;
    var t = saved.cloneNode(true);
    t.setAttribute('data-gllf-tile', 'lists'); t.classList.remove('gllf-tile--saved', 'has-items'); t.classList.add('gllf-tile--lists');
    t.setAttribute('href', '/pages/wishlist');
    var icon = t.querySelector('.gllf-tile__icon');
    if (icon) icon.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7.5" height="9" rx="2"/><rect x="13.5" y="3" width="7.5" height="5.5" rx="2"/><rect x="3" y="15" width="7.5" height="6" rx="2"/><rect x="13.5" y="11.5" width="7.5" height="9.5" rx="2"/></svg>';
    var b = t.querySelector('.gllf-tile__text b'); if (b) b.textContent = 'My lists';
    var sm = t.querySelector('.gllf-tile__text small'); if (sm) { sm.removeAttribute('data-gllf-tile-sub'); sm.textContent = 'Garden, pantry, gifts'; }
    t.removeAttribute('aria-label');
    t.querySelectorAll('[data-gllf-tile-count]').forEach(function (n) { n.remove(); });
    saved.insertAdjacentElement('afterend', t);
  }
  function initTiles(mobile) {
    addListsTile(mobile);
    if (!mobile.querySelector('[data-gllf-tile="lists"]')) {
      var retry = function () { addListsTile(mobile); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', retry); else setTimeout(retry, 0);
      window.addEventListener('load', retry);
    }
    function sync() {
      [['wishlist', 'gllf_saved_v1'], ['compare', 'gllf_compare_v1']].forEach(function (p) {
        var n = read(p[1]).length;
        mobile.querySelectorAll('[data-gllf-tile-count="' + p[0] + '"]').forEach(function (b) { b.textContent = p[0] === 'compare' ? n + '/4' : n; b.hidden = n === 0; });
        mobile.querySelectorAll('[data-gllf-tile-sub="' + p[0] + '"]').forEach(function (s) {
          s.textContent = p[0] === 'compare'
            ? (n === 0 ? 'Up to 4 side by side' : n === 1 ? 'Add 1 more to compare' : n + ' ready to compare')
            : (n === 0 ? 'Plants you love' : n + (n === 1 ? ' saved plant' : ' saved plants'));
        });
        mobile.querySelectorAll('[data-gllf-tile="' + p[0] + '"]').forEach(function (t) { t.classList.toggle('has-items', n > 0); });
      });
    }
    sync();
    document.addEventListener('gllf:saved:changed', function () { setTimeout(sync, 0); });
    window.addEventListener('storage', sync);
    mobile.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gllf-tile]');
      if (!t || !window.GLLFShortlist || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      closeMenu(mobile);
      setTimeout(function () { window.GLLFShortlist.open(t.dataset.gllfTile); }, 260);
    });
  }

  function initSearch(mobile) {
    if (window.GLLFSmartSearch) { window.GLLFSmartSearch.init(); return; } /* design-v1: gllf-search-v1.js runs this box */
    var form = mobile.querySelector('.gllf-mega-mobile__search');
    if (!form || form.dataset.gllfSmart) return;
    form.dataset.gllfSmart = '1';
    var input = form.querySelector('input[type="search"]');
    var screen = form.closest('[data-gllf-mobile-screen]');
    form.classList.add('gllf-ss');
    input.setAttribute('autocomplete', 'off'); input.setAttribute('autocapitalize', 'off'); input.setAttribute('spellcheck', 'false');
    input.setAttribute('enterkeyhint', 'search'); input.setAttribute('role', 'combobox'); input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', 'GLLFSmartResults'); input.setAttribute('aria-autocomplete', 'list');
    input.placeholder = 'Search plants & products';

    var tools = document.createElement('span'); tools.className = 'gllf-ss__tools';
    tools.innerHTML = '<button type="button" class="gllf-ss__clear" aria-label="Clear search" hidden>×</button>' +
      ((window.SpeechRecognition || window.webkitSpeechRecognition) ? '<button type="button" class="gllf-ss__mic" aria-label="Search by voice">' + ICON('M12 15a3 3 0 0 0 3-3V6a3 3 0 1 0-6 0v6a3 3 0 0 0 3 3Zm-6-3a6 6 0 0 0 12 0M12 18v3') + '</button>' : '');
    input.insertAdjacentElement('afterend', tools);
    var clearBtn = tools.querySelector('.gllf-ss__clear'), mic = tools.querySelector('.gllf-ss__mic');

    var panel = document.createElement('div'); panel.className = 'gllf-ss__panel'; panel.id = 'GLLFSmartResults'; panel.hidden = true;
    panel.setAttribute('aria-live', 'polite');
    form.insertAdjacentElement('afterend', panel);

    function setMode(on) {
      screen.classList.toggle('gllf-is-searching', on); panel.hidden = !on; input.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function home() {
      var recent = read(RECENT);
      panel.innerHTML =
        (recent.length ? '<div class="gllf-ss__sec"><div class="gllf-ss__head"><span>Recent</span><button type="button" class="gllf-ss__link" data-ss-clear-recent>Clear</button></div><div class="gllf-ss__chips">' +
          recent.map(function (q) { return '<button type="button" class="gllf-ss__chip gllf-ss__chip--recent" data-ss-q="' + esc(q) + '">' + ICON('M12 7v5l3 2M21 12a9 9 0 1 1-3-6.7M21 4v5h-5') + '<span>' + esc(q) + '</span></button>'; }).join('') + '</div></div>' : '') +
        '<div class="gllf-ss__sec"><div class="gllf-ss__head"><span>Popular right now</span></div><div class="gllf-ss__chips">' +
          POPULAR.map(function (q) { return '<button type="button" class="gllf-ss__chip" data-ss-q="' + esc(q) + '">' + esc(q) + '</button>'; }).join('') + '</div></div>' +
        '<div class="gllf-ss__sec"><div class="gllf-ss__head"><span>Helpful tools</span></div><div class="gllf-ss__tools-grid">' +
          TOOLS.map(function (t) { return '<a class="gllf-ss__tool" href="' + t[1] + '">' + ICON(t[2]) + '<span>' + t[0] + '</span></a>'; }).join('') + '</div></div>';
    }
    var timer, seq = 0, active = -1;
    function suggest(q) {
      var my = ++seq;
      panel.innerHTML = '<div class="gllf-ss__loading"><span></span><span></span><span></span></div>';
      var u = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,query&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,tag';
      fetch(u).then(function (r) { return r.json(); }).then(function (j) {
        if (my !== seq) return;
        var R = (j.resources && j.resources.results) || {};
        var prods = R.products || [], cols = R.collections || [], pages = R.pages || [], queries = (R.queries || []).filter(function (x) { return x.text.toLowerCase() !== q.toLowerCase(); }).slice(0, 4);
        var html = '';
        if (queries.length) html += '<div class="gllf-ss__chips gllf-ss__chips--q">' + queries.map(function (x) { return '<button type="button" class="gllf-ss__chip" data-ss-q="' + esc(x.text) + '">' + ICON('M11 4a7 7 0 1 0 4.2 12.6L20 21.4 21.4 20l-4.8-4.8A7 7 0 0 0 11 4Z') + '<span>' + mark(x.text, q) + '</span></button>'; }).join('') + '</div>';
        if (prods.length) html += '<div class="gllf-ss__sec"><div class="gllf-ss__head"><span>Products</span></div><ul class="gllf-ss__list" role="listbox">' + prods.map(function (p) {
          var im = p.image || (p.featured_image && p.featured_image.url) || '';
          return '<li role="option"><a class="gllf-ss__prod" href="' + esc(p.url) + '" data-ss-go="' + esc(q) + '">' + (im ? '<img src="' + esc(img(im)) + '" alt="" width="56" height="56" loading="lazy">' : '<span class="gllf-ss__ph"></span>') +
            '<span class="gllf-ss__pt"><b>' + mark(p.title, q) + '</b><small>' + (p.available === false ? '<em>Pre-order / notify</em>' : '<em class="ok">Available</em>') + ((p.type || p.product_type) ? ' · ' + esc(p.type || p.product_type) : '') + '</small></span><span class="gllf-ss__price">' + money(p.price) + '</span></a></li>';
        }).join('') + '</ul></div>';
        var links = cols.map(function (c) { return ['Collection', c.title, c.url]; }).concat(pages.map(function (p) { return ['Guide & tools', p.title, p.url]; })).slice(0, 6);
        if (links.length) html += '<div class="gllf-ss__sec"><div class="gllf-ss__head"><span>Collections & pages</span></div><ul class="gllf-ss__list" role="listbox">' + links.map(function (l) {
          return '<li role="option"><a class="gllf-ss__row" href="' + esc(l[2]) + '" data-ss-go="' + esc(q) + '"><span class="gllf-ss__tag">' + l[0] + '</span><span>' + mark(l[1], q) + '</span><span aria-hidden="true">›</span></a></li>';
        }).join('') + '</ul></div>';
        if (!html) html = '<div class="gllf-ss__empty"><b>No matches for “' + esc(q) + '”</b><p>Try a cultivar name like Hidcote, or ask our grower assistant.</p><button type="button" class="gllf-ss__cta gllf-ss__cta--ghost" data-ss-chat="' + esc(q) + '">Ask Lavender Grower</button></div>';
        html += '<button type="submit" class="gllf-ss__cta">See all results for “' + esc(q) + '” →</button>';
        panel.innerHTML = html; active = -1;
      }).catch(function () { if (my === seq) panel.innerHTML = '<button type="submit" class="gllf-ss__cta">Search for “' + esc(q) + '” →</button>'; });
    }
    function onInput() {
      var q = input.value.trim(); clearBtn.hidden = !input.value;
      clearTimeout(timer);
      if (q.length < 2) { home(); return; }
      timer = setTimeout(function () { suggest(q); }, 180);
    }
    input.addEventListener('focus', function () { setMode(true); onInput(); });
    input.addEventListener('input', onInput);
    input.addEventListener('keydown', function (e) {
      var opts = Array.prototype.slice.call(panel.querySelectorAll('a.gllf-ss__prod, a.gllf-ss__row'));
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!opts.length) return; e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts.forEach(function (o, i) { o.classList.toggle('is-active', i === active); }); opts[active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && active >= 0 && opts[active]) { e.preventDefault(); addRecent(input.value); location.href = opts[active].href; }
      else if (e.key === 'Escape') { if (input.value) { input.value = ''; onInput(); } else { input.blur(); setMode(false); } }
    });
    clearBtn.addEventListener('click', function () { input.value = ''; input.focus(); onInput(); });
    form.addEventListener('submit', function () { addRecent(input.value); });
    panel.addEventListener('click', function (e) {
      var q = e.target.closest('[data-ss-q]');
      if (q) { input.value = q.dataset.ssQ; input.focus(); onInput(); return; }
      if (e.target.closest('[data-ss-clear-recent]')) { write(RECENT, []); home(); input.focus(); return; }
      var go = e.target.closest('[data-ss-go]'); if (go) addRecent(go.dataset.ssGo);
      var chat = e.target.closest('[data-ss-chat]');
      if (chat) { closeMenu(mobile); var b = document.querySelector('[aria-label="Ask Lavender Grower"]'); if (b) b.click(); else location.href = '/pages/lavender-grower-chat'; }
    });
    // Leave search mode when the user taps outside the search area (keeps the menu reachable).
    screen.addEventListener('click', function (e) { if (!form.contains(e.target) && !panel.contains(e.target)) setMode(false); });
    var cancel = document.createElement('button'); cancel.type = 'button'; cancel.className = 'gllf-ss__cancel'; cancel.textContent = 'Cancel';
    form.insertAdjacentElement('afterend', cancel);
    cancel.addEventListener('click', function () { input.value = ''; clearBtn.hidden = true; input.blur(); setMode(false); });
    if (mic) {
      mic.addEventListener('click', function () {
        var SR = window.SpeechRecognition || window.webkitSpeechRecognition, rec = new SR();
        rec.lang = 'en-US'; rec.interimResults = true; mic.classList.add('is-listening'); setMode(true);
        rec.onresult = function (ev) { input.value = Array.prototype.map.call(ev.results, function (r) { return r[0].transcript; }).join(''); onInput(); };
        rec.onend = function () { mic.classList.remove('is-listening'); input.focus(); };
        rec.onerror = function () { mic.classList.remove('is-listening'); };
        try { rec.start(); } catch (err) { mic.classList.remove('is-listening'); }
      });
    }
    // When the drawer closes, reset search mode.
    var root = mobile.querySelector('[data-gllf-mobile-root]');
    if (root) root.addEventListener('toggle', function () { if (!root.open) setMode(false); });
  }

  function init() {
    document.querySelectorAll('[data-gllf-mega-mobile]').forEach(function (m) {
      if (m.dataset.gllfTiles) return; m.dataset.gllfTiles = '1';
      initTiles(m); initSearch(m);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 0); }); else setTimeout(init, 0);
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
